import { render, staticRenderFns } from "./banshouliPreview.vue?vue&type=template&id=0ceecc13&scoped=true&"
import script from "./banshouliPreview.vue?vue&type=script&lang=js&"
export * from "./banshouliPreview.vue?vue&type=script&lang=js&"
import style0 from "./banshouliPreview.vue?vue&type=style&index=0&id=0ceecc13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ceecc13",
  null
  
)

export default component.exports